import { PageSkeleton } from '@app/components/page/header/skeleton/PageSkeleton';
import { Box, Grid, Skeleton } from '@mui/material';

/**
 * Loading placeholder for saved-report detail pages (GIP, GIP alt, broadcast evidence).
 * Mirrors BaseReportPage header + BaseReportView info/actions layout.
 */
export function ReportsViewPageSkeleton() {
  return (
    <PageSkeleton breadcrumbs={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Box mb={2}>
            <Skeleton variant="text" width={140} sx={{ typography: 'body2', mb: 0.5 }} />
            <Skeleton variant="text" width="55%" sx={{ typography: 'body1' }} />
          </Box>

          <Box mb={2}>
            <Skeleton variant="text" width={48} sx={{ typography: 'body2', mb: 0.5 }} />
            <Skeleton variant="rounded" width={96} height={24} />
          </Box>

          <Box mb={2} display="flex" gap={4} flexWrap="wrap">
            <Box>
              <Skeleton variant="text" width={120} sx={{ typography: 'body2', mb: 0.5 }} />
              <Skeleton variant="text" width={160} sx={{ typography: 'body1' }} />
            </Box>
            <Box>
              <Skeleton variant="text" width={80} sx={{ typography: 'body2', mb: 0.5 }} />
              <Skeleton variant="text" width={120} sx={{ typography: 'body1' }} />
            </Box>
          </Box>

          <Box mt={3}>
            <Skeleton variant="text" width={180} sx={{ typography: 'subtitle2', mb: 1.5 }} />
            <Skeleton variant="rounded" width="100%" height={120} />
          </Box>

          <Box mt={3}>
            <Skeleton variant="text" width={160} sx={{ typography: 'subtitle2', mb: 1.5 }} />
            <Skeleton variant="rounded" width="100%" height={72} />
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Box display="flex" flexDirection="column" gap={1.5}>
            <Skeleton variant="rounded" width="100%" height={36} />
            <Skeleton variant="rounded" width="100%" height={36} />
            <Skeleton variant="rounded" width="70%" height={36} />
          </Box>
        </Grid>
      </Grid>
    </PageSkeleton>
  );
}
